export type CategoryLinks = {
  [key: string]: string
}

export const categoryLinks: CategoryLinks = {
  'Solarium Sunselect': 'sunpoint/braeune/solarium',
  Bräunungsdusche: 'sunpoint/braeune/spray-tanning-braeunungsdusche',
  'Collagen Solarium': 'sunpoint.de/sunpoint/braeune/collagen',
  'Farblichttherapie Solarium': 'sunpoint/braeune/collagen',
  Gewichtsreduktion: 'wellmaxx/gewichtsreduktion',
  'Lymphaktivierende Massage': 'wellmaxx/koerperstraffung',
  Vibrationstraining: 'wellmaxx/vibrationstraining',
  Farblichttherapie: 'sunpoint/bodyforming/farblichttherapie',
  Solarkosmetik: 'sunpoint/kosmetik/solarkosmetik',
  Wirkkosmetik: 'sunpoint/kosmetik/wirkkosmetik',
  Körperstraffung: 'wellmaxx/koerperstraffung',
  Kosmetik: 'wellmaxx/kosmetik',
  'Wellmaxx Club': 'wellmaxx/konzept/club',
}
